const AbstractItem = require('@/lib/Items/AbstractItem');
const ItemType = require('@/lib/Items/ItemType');
const { toBool } = require('@/functions/transform');

class Bundle extends AbstractItem {
    constructor() {
        super();

        this.singleDayBundle = false;
        this.itemType = ItemType.BUNDLE;
    }

    /**
     * @returns {object}
     */
    getHydrationMap() {
        return Object.assign(
            super.getHydrationMap(),
            {
                singleDayBundle: {
                    field: ['singleDayBundle', 'allowPriceEdit'],
                    transform: toBool,
                },
            }
        );
    }
}

module.exports = Bundle;
